/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import { FC } from 'react';
import { useArchitectureInfoContext } from '../../../contexts/ArchitectureContext/context';
import { ArchitectureInfoSchema, EditableComponentBaseProps } from '../../../customTypes';
import BaseDiagramInfo from '../../generic/BaseDiagramInfo';

const ArchitectureInfo: FC<EditableComponentBaseProps> = (props) => {
  const { architectureInfo, setArchitectureInfo } = useArchitectureInfoContext();
  return (
    <BaseDiagramInfo
      {...props}
      headerTitle='Architecture'
      diagramTitle='Architecture Diagram'
      entity={architectureInfo}
      onConfirm={(diagram) => setArchitectureInfo(diagram)}
      validateData={ArchitectureInfoSchema.shape.description.safeParse}
    />);
};

export default ArchitectureInfo;